
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { FinanceChartProps } from '@/types/database';

interface ExtendedFinanceChartProps extends FinanceChartProps {
  transactions?: any[];
  expensesByCategory?: Record<string, number>;
  incomeByCategory?: Record<string, number>;
}

export function FinanceChart({ data, type, colors, transactions, expensesByCategory, incomeByCategory }: ExtendedFinanceChartProps) {
  // If we have category data, transform it for charts
  if (expensesByCategory || incomeByCategory) {
    const categoryData = [];
    
    // Process expense categories
    if (expensesByCategory) {
      Object.entries(expensesByCategory).forEach(([category, amount]) => {
        categoryData.push({
          name: category,
          value: amount
        });
      });
    }
    
    // If we have category data but no direct data, use the category data
    if (categoryData.length > 0 && (!data || data.length === 0) && type === 'pie') {
      data = categoryData;
    }
  }
  
  if (type === 'pie') {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={true}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value: number) => [`R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 'Valor']}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    );
  }
  
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip 
          formatter={(value: number) => [`R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, '']}
        />
        <Legend />
        <Bar dataKey="Receitas" fill={colors[0]} />
        <Bar dataKey="Despesas" fill={colors[1]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
